import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import { ActivityType } from 'types/interfaces/activity';
import { ACTIVITY_TYPE_CONFIG, ALL_ACTIVITY_TYPES } from '../constants';
import './ActivityFilterBar.css';

interface ActivityFilterBarProps {
  activeTypes: Set<ActivityType>;
  toggleType: (type: ActivityType) => void;
  isPaused: boolean;
  togglePause: () => void;
  pendingCount: number;
}

const ActivityFilterBar: React.FC<ActivityFilterBarProps> = ({
  activeTypes,
  toggleType,
  isPaused,
  togglePause,
  pendingCount,
}) => {
  return (
    <div className="activity-filter-bar">
      <div className="activity-filter-bar__pills">
        {ALL_ACTIVITY_TYPES.map((type) => {
          const config = ACTIVITY_TYPE_CONFIG[type];
          const isActive = activeTypes.has(type);

          return (
            <button
              key={type}
              className={`activity-filter-bar__pill${isActive ? ' activity-filter-bar__pill--active' : ''}`}
              onClick={() => toggleType(type)}
              style={{
                borderColor: isActive ? config.color : 'rgba(255, 255, 255, 0.15)',
                backgroundColor: isActive ? config.bgColor : 'transparent',
                color: isActive ? config.color : 'rgba(255, 255, 255, 0.35)',
              }}
              type="button"
              aria-pressed={isActive}
              aria-label={`Filter ${config.label} activities`}
            >
              <FontAwesomeIcon icon={config.icon} className="activity-filter-bar__pill-icon" />
              {config.label}
            </button>
          );
        })}
      </div>

      <button
        className={`activity-filter-bar__pause${isPaused ? ' activity-filter-bar__pause--active' : ''}`}
        onClick={togglePause}
        type="button"
        aria-label={isPaused ? `Resume feed (${pendingCount} pending)` : 'Pause feed'}
      >
        <FontAwesomeIcon icon={isPaused ? faPlay : faPause} />
        <span>{isPaused ? 'Resume' : 'Pause'}</span>
        {isPaused && pendingCount > 0 && (
          <span className="activity-filter-bar__pending-badge">{pendingCount}</span>
        )}
      </button>
    </div>
  );
};

export default ActivityFilterBar;
